import { IAccountByIdRawRespDto } from './account.type'
import { IMessageResponseDto } from './common.type'
import { IImpactBaseWithId, IImpactByIdRawRespDto } from './impacts.type'
import { IMedia, IMediaBase, IMediaFiles } from './media.type'
import { IProductByIdRawRespDto } from './product.type'
import { IStepByIdRawRespDto } from './step.type'
import { IUserByIdRawRespDto } from './user.type'

export interface IScanCreateForm {
  scanner_latitude: number
  scanner_longitude: number

  batch_id: string

  sender_reference_id: string | null
  receiver_reference_id: string | null
  invoice_reference: string | null

  impact_quantity: string | null
  impact_id: string | null

  note: string
  media: IMediaFiles

  account_id: string
  product_id: string
  step_id: string
}

export interface IScanCreateDto {
  scanner_latitude: number
  scanner_longitude: number

  record_type: EScanRecordType

  batch_id: string

  sender_reference_id: string | null
  receiver_reference_id: string | null
  invoice_reference: string | null

  impact_quantity: string | null
  impact_id: string | null

  note: string
  media: IMediaBase[]

  account_id: string
  product_id: string
  step_id: string
}

export interface IQRCodeScanDto {
  payload: string
}

export interface IScanUpdateReviewedDto {
  id: string
  reviewed: boolean
  accountId: string | undefined
}

export interface IScanUpdateStatusDto {
  id: string
  status: EScanStatus
  accountId: string | undefined
}

export interface IQRCodeScanRespDto extends IMessageResponseDto {
  product: IProductByIdRawRespDto
  account: IAccountByIdRawRespDto
}

export interface IScanCreateInitialValuesResp extends Partial<IScanCreateForm> {
  product: IProductByIdRawRespDto | null
  account: IAccountByIdRawRespDto | null
  step: IStepByIdRawRespDto | null
  impact: { id: string } | null

  record_type: EScanRecordType
}

export interface IScanRespDto {
  id: string
  created_at: Date

  batch_id: string
  record_type: EScanRecordType
  status: EScanStatus

  sender_reference_id: string | null
  receiver_reference_id: string | null
  invoice_reference: string | null

  note: string | null
  media: IMedia[]

  reviewed_at: Date | null
  reviewed_by: string | null
  not_approved_by: string | null
  not_approved_on: Date | null

  account_tx: string | null
  pushed_by: string | null
  pushed_at: Date | null
  user_tx: string | null

  within_geofence: boolean

  product_name: string
  product_code: string
  product: IProductByIdRawRespDto | null

  account_name: string
  account: IAccountByIdRawRespDto | null

  step_name: string
  step_code: string
  step_latitude: number
  step_longitude: number
  step: IStepByIdRawRespDto | null

  scanner_name: string
  scanner_email: string
  scanner_latitude: number
  scanner_longitude: number
  step_radius: number
  scanner: IUserByIdRawRespDto | null

  impact_quantity: string | null
  impact_quantity_type: string | null
  impact: IImpactByIdRawRespDto | null

  account_role_for_user: EScanAccountUserRoles
  network: EScanNetwork
}

export interface IScansStatusCount {
  approved: number
  new: number
  not_approved: number
  'on-chain': number
}

export interface IScansRespDto {
  data: IScanRespDto[]
  count: number
  // statusCount: IScansStatusCount
}

export enum EScanAccountUserRoles {
  OWNER = 'owner',
  ADMIN = 'admin',
  USER = 'user',
  SCANNER = 'scanner',
}

export enum EScanRecordType {
  General = 'general',
  Impact = 'impact',
  Movement = 'movement',
}

export enum ECreateScanMode {
  Default = 'account_product_scan',
  AccountImpact = 'account_impact',
  ProductImpact = 'product_impact',
}

export enum EScanStatus {
  NEW = 'new',
  APPROVED = 'approved',
  NOT_APPROVED = 'not_approved',
  ON_CHAIN = 'on-chain',
}

export enum EScanNetwork {
  BASE = 'base',
  POLYGON = 'polygon',
}

export interface IScanIdsRespDto {
  data: string[]
}

export interface IScanReferenceIdsRespDto {
  senderReferenceIds: string[]
  receiverReferenceIds: string[]
  invoiceReferences: string[]
}

export interface IUnreviewedScansCountRespDto {
  count: number
}

export interface IScanMessageResponseWithBalance {
  message: string
  balanceMessage: string | null
}

export interface ICoords {
  lat: number
  lng: number
}

export interface IStepLocation extends ICoords {
  name?: string
  radius: number
  location_name?: string
  connected_account_name: string | null
  connected_account_img: string | null
}

export interface IScanImpact
  extends Pick<
    IImpactBaseWithId,
    'id' | 'name' | 'code' | 'image' | 'image_small' | 'image_medium'
  > {}

export interface IScanProductImpact extends IScanImpact {}

export interface IScanAccountImpact extends IScanImpact {}

export interface IScanProductImpactsRespDto {
  count: number
  data: IScanProductImpact[]
}

export interface IScanAccountImpactsRespDto {
  count: number
  data: IScanProductImpact[]
}
